import './../app/shared/operators';

import { of } from 'rxjs/observable/of';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Action } from '@ngrx/store';
import { Effect, Actions } from '@ngrx/effects';

import * as s from '../actions/sector.actions';

import { Api } from '../providers/api/api';

@Injectable()
export class SectorEffects {
  constructor(private actions$: Actions, private api: Api, ) { }

  @Effect()
  fetchFilters$: Observable<Action> = this.actions$
    .ofType(s.FETCH_SECTORS)
    .map((action: s.FetchSectors) => {
      return action;
    })
    .switchMap((payload) => this.api.fetchSectors())
    .map(sectors => {
      return new s.FetchSectorsSuccess(sectors);
    }).catch((err) => of(new s.FetchSectorsFailure(err)));

}





// WEBPACK FOOTER //
// ./src/effects/sector.effect.ts